import {useAppState} from 'store/utils';

export function useDailyBudgetStore(): DailyBudgetState {
  return useAppState().dailyBudget;
}
